/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppliedDiscount
 */
export interface AppliedDiscount {
    /**
     * 
     * @type {string}
     * @memberof AppliedDiscount
     */
    discountId: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppliedDiscount
     */
    name: string | null;
    /**
     * 
     * @type {number}
     * @memberof AppliedDiscount
     */
    amount: number;
}

/**
 * Check if a given object implements the AppliedDiscount interface.
 */
export function instanceOfAppliedDiscount(value: object): value is AppliedDiscount {
    if (!('discountId' in value) || value['discountId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function AppliedDiscountFromJSON(json: any): AppliedDiscount {
    return AppliedDiscountFromJSONTyped(json, false);
}

export function AppliedDiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppliedDiscount {
    if (json == null) {
        return json;
    }
    return {
        
        'discountId': json['discountId'],
        'name': json['name'],
        'amount': json['amount'],
    };
}

export function AppliedDiscountToJSON(json: any): AppliedDiscount {
    return AppliedDiscountToJSONTyped(json, false);
}

export function AppliedDiscountToJSONTyped(value?: AppliedDiscount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discountId': value['discountId'],
        'name': value['name'],
        'amount': value['amount'],
    };
}

